import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  position: relative;
  cursor: help;

  div {
    visibility: hidden;
    position: absolute;
    background-color: ${({ theme }) => theme.colors.black};
    text-align: center;
    border-radius: 6px;
    padding: 10px 20px;
    position: absolute;
    z-index: 5;
    width: max-content;
    bottom: 150%;
    left: 60%;
    transform: translateX(-50%);

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: ${({ theme }) => theme.colors.black} transparent transparent
        transparent;
    }

    span {
      white-space: pre-wrap;
      font-weight: 400;
      color: ${({ theme }) => darken(0.05, theme.colors.lightGrey)};
    }

    strong {
      display: block;
      margin-top: 10px;
      color: ${({ theme }) => theme.colors.white};
      font-weight: 700;
      font-size: 14px;
    }
  }

  &:hover div {
    visibility: visible;
  }

  svg {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grey};
  }
`;
